import React from 'react';
import { useIntl } from 'react-intl-next';
import { Box, Text, xcss } from '@atlaskit/primitives';
import { messages } from './messages';
const permissionErrorWrapperStyles = xcss({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
export const PermissionErrorMessage = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(Box, {
    xcss: permissionErrorWrapperStyles,
    testId: "proforma-form-system-permission-error"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    as: "p"
  }, formatMessage(messages.description)));
};